import React, { useEffect, useRef, useState } from "react";
import styles from "./reachOutSection.module.css";
import "../../src/common/grid.css";
import Image from "next/image";
import { useRouter } from "next/navigation";

const ReachOutSection = ({ title, buttonText, buttonIcon }) => {
  const router = useRouter();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "0px",
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const handleBookingClick = () => {
    router.push("/booking");
  };

 
  return (
    <div ref={sectionRef} className={styles.reachOutSection}>
      <div className="container">
        <div className={styles.reachOutContentWrapper}>
          <h2 className={styles.reachOutTitle}>{title}</h2>
          <button
            className={`${styles.reachOutButton} ${
              isVisible ? styles.visible : ""
            }`}
            onClick={handleBookingClick}
          >
            <Image
              src={buttonIcon}
              alt="calendar icon"
              width={20}
              height={20}
            />
            <span>{buttonText}</span>
          </button>
        </div>
      </div>
     
    </div>
  );
};

export default ReachOutSection;
